<template>
  <div class="container status">
    <div v-if="status && status.submission.submitted">
      <div class="success-head">
        <h1>Application Submitted!</h1>
      </div>
      <main class="success-main">
        <div>
          <p>
            Thank you for applying to the {{status.organization.name}}  for the
            {{status.scholarship.name }}!
          </p>
        </div>
        <div>
          <p>You successfully submitted your application on
            <strong> {{status.submission.submitted_at.slice(0,10)}}.</strong>
          </p>
        </div>
        <div>
          <p>
            This scholarship closes on <strong>{{status.scholarship.close_date }}</strong>.
            The reviewing process will begin after this date.
          </p>
        </div>
        <div v-if="status.scholarship.status.length !== 0">
          <section v-html="status.scholarship.status"></section>
        </div>
      </main>
      <router-link :to="{ name: 'review',
        params: { organization_name: $route.params.organization_name,
        scholarship_name: $route.params.scholarship_name }}">
        Review My Submission
      </router-link>
    </div>
    <div v-else-if="status">
      <div class="status-header">
        <h1>Your Application is in Progress</h1>
      </div>
      <main class="status-main">
        <p>You are applying for the {{status.scholarship.name}} that closes on <strong>{{status.scholarship.close_date}}</strong></p>
        <p>
          To continue your application click
          <router-link :to="{ name: 'apply',
            params: { organization_name: $route.params.organization_name,
            scholarship_name: $route.params.scholarship_name }}">
            Apply Now
          </router-link>
          .
        </p>
        <div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
  import axios from '../../auth.js'
  export default {
    data(){
      return {
        status: null
      }
    },
    mounted(){
      axios.get(
        `${process.env.VUE_APP_ENDPOINT}/api/applicant/${this.$route.params.organization_name}/${this.$route.params.scholarship_name}/status/`
      ).then(res => {
        this.status = res.data
        if (!this.status.submission) {
          this.$router.push({name: 'information'})
        }
      })
      .catch(err => {
          if( err.response && err.response.status === 404 ){
          this.$router.push({name: 'notFound'})
          }
         if( err.response && err.response.status === 500 ){
          this.$toasted.error("Oops, it looks like you haven't started an application yet!", {
                theme: "outline",
                position: "top-right",
                duration : 10000
            })
          this.$router.push({name: 'apply'})
          }
      })
    },
    methods:{
      
    },
  }
</script>
<style>
</style>

